








import { Prop, Vue, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import Tariff from '@/dto/deliveries/Tariff'
import HotService from '@/services/HotService'
import Hot from '@/services/hot/Hot'
import TariffsTableHeader from '@/components/delivery/tariffs/TariffsTableHeader.vue'
import TariffsService from '@/services/TariffsService'
import { NotifyHelper } from 'vue-kit'
import { Routes } from '@/router/routes'

const hot = new Hot()

@Component({
  components: { TariffsTableHeader },
})
export default class TariffsTable extends Vue {
  @Prop(Number)
  deliveryId: number

  @Prop(Object)
  tableData: { tariffs: Tariff[]; zoneNames: { [key: number]: string } }

  isPending: boolean = false

  get tariffs(): Tariff[] {
    return this.tableData.tariffs
  }

  get zoneNames(): { [key: number]: string } {
    return this.tableData.zoneNames
  }

  mounted() {
    this.initHot()
  }

  initHot() {
    const config = HotService.getTariffsSettings(
      this.tariffs[0],
      this.zoneNames
    )

    hot.init(this.$refs.mountPoint as Element, config)
    hot.loadData(this.tariffs)
    hot.hotInstance.updateSettings({ minSpareRows: 1 })
  }

  saveTariffs() {
    const tariffs = this.getChangedTariffs()

    if (!tariffs.length) {
      return
    }

    this.isPending = true
    TariffsService.saveTariffs(this.deliveryId, tariffs)
      .then(tariffs => this.$emit('save', tariffs))
      .catch(() => NotifyHelper.error('Ошибка сервера'))
      .finally(() => (this.isPending = false))
  }

  cancelChanges() {
    this.$router.push({ name: Routes.deliveries })
  }

  getChangedTariffs(): Tariff[] {
    const changes = hot.getChanges()
    const changedRows = new Set(changes.map(change => change.rowIndex))
    return hot.viewData.filter((row, index) => changedRows.has(index))
  }

  @Watch('tableData')
  updateTable() {
    const config = HotService.getTariffsSettings(
      this.tariffs[0],
      this.zoneNames
    )
    hot.hotInstance.updateSettings({ ...(config as any), minSpareRows: 0 })
    hot.loadData([...this.tariffs])
    hot.hotInstance.updateSettings({ minSpareRows: 1 })
    hot.changes = []
  }

  rerenderHot() {
    hot.hotInstance.destroy()
    this.initHot()
    hot.loadData(hot.editData)
  }

  @Watch('layoutStore.isShowLeftSidebar')
  rerenderTable(value: boolean | number) {
    if (typeof value === 'boolean') {
      setTimeout(() => {
        this.rerenderHot()
      }, 500)
    } else {
      this.rerenderHot()
    }
  }
}
